// TODO: move to packages and reuse across backoffice, personal and station apps

import { computed } from 'vue'
import { useAuthStore } from '~/stores/auth'
import type { MenuLanguage } from '@restify/packages/types/typebox/apps.schema'

export function translateField(field: { menuLanguageId: string; text: string }[], languageId: string) {
  const fallbackItem = field.find((item) => item.menuLanguageId === languageId)

  return fallbackItem ? fallbackItem.text : 'No text'
}

export default function useFallbackLanguage(field: { menuLanguageId: string; text: string }[], fallback?: MenuLanguage) {
  const AuthStore = useAuthStore()
  const menulanguages = AuthStore.userApp?.menuLanguages || []
  const fallbackLanguage = computed(
    () => fallback || menulanguages.find((language) => language.fallback),
  )

  const currentFallbackLanguage = fallbackLanguage.value
  
  if (!currentFallbackLanguage) return field[0]?.text || '[i18n-content]'

  const fallbackItem = Array.isArray(field)
    ? field.find((item) => item.menuLanguageId === currentFallbackLanguage._id)
    : undefined

  return fallbackItem ? fallbackItem.text : field?.[0]?.text || 'No text'
}

export function useInternalName(
  field: { menuLanguageId: string; text: string }[],
  internalName?: string,
) {
  if (internalName) return internalName

  const AuthStore = useAuthStore()
  const menulanguages = AuthStore.userApp?.menuLanguages || []
  const fallbackLanguage = computed(() =>
    menulanguages.find((language) => language.fallback),
  )

  return useFallbackLanguage(field, fallbackLanguage.value)
}
